export default {
    title: 'Projekty',
    subtitle: '{n} projekt | {n} projekty | {n} projektów',
    newProject: 'Nowy projekt',
    untitled: 'Projekt bez nazwy',
    titlePlaceholder: 'Nazwa projektu, np. Remont łazienki',
    titleLabel: 'Nazwa projektu',
    progress: '{done} z {total}',
    allDone: 'Wszystko zrobione — zakończyć projekt?',
    addTask: 'Dodaj zadanie',
    addTaskTo: 'Dodaj zadanie do „{name}"',
    done: 'Zrobione ({n})',
    empty: {
        title: 'Nie masz jeszcze projektów',
        text: 'Projekt to coś z celem i końcem — remont, przeprowadzka, wyjazd — rozpisane na zadania.',
    },
    pick: {
        title: 'Wybierz projekt',
        text: 'Albo zacznij nowy — od zera albo z szablonu.',
    },
    finished: {
        title: 'Zakończone',
        back: 'Wróć do projektów',
        open: 'Zakończone ({n})',
        empty: 'Nie ma jeszcze zakończonych projektów',
    },
    due: {
        today: 'termin dziś',
        tomorrow: 'termin jutro',
        in: 'za {n} dzień | za {n} dni | za {n} dni',
        overdue: 'po terminie ({n} dzień) | po terminie ({n} dni) | po terminie ({n} dni)',
    },
    day: {
        today: 'dziś',
        tomorrow: 'jutro',
        yesterday: 'wczoraj',
    },
    toolbar: {
        back: 'Wróć do listy projektów',
        due: 'Termin projektu',
        addDue: 'Termin',
        dueOn: '{date} · {when}',
        clearDue: 'Usuń termin',
        finishedOn: 'Zakończony {date}',
        pin: 'Przypnij',
        unpin: 'Odepnij',
        finish: 'Zakończ projekt',
        restore: 'Przywróć',
        more: 'Więcej',
        saveTemplate: 'Zapisz jako szablon',
        remove: 'Usuń projekt',
    },
    section: {
        new: 'Nowa sekcja',
        untitled: 'Sekcja',
        name: 'Nazwa sekcji',
        add: 'Dodaj sekcję',
        collapse: 'Zwiń sekcję',
        expand: 'Rozwiń sekcję',
        remove: 'Usuń sekcję „{name}" (zadania zostają)',
    },
    task: {
        text: 'Treść zadania',
        drag: 'Przeciągnij, żeby przenieść',
        when: 'Kiedy',
        remove: 'Usuń zadanie',
        today: 'Dziś',
        tomorrow: 'Jutro',
        day: 'Dzień',
        noDay: 'Bez dnia',
        time: 'Godzina',
        timeNeedsDay: 'Godzina wymaga dnia.',
        more: 'Powtarzanie i przypomnienie…',
    },
    templates: {
        title: 'Szablony',
        subtitle: '{n} szablon | {n} szablony | {n} szablonów',
        newTemplate: 'Nowy szablon',
        newName: 'Nowy szablon',
        untitled: 'Szablon bez nazwy',
        intro: 'Gotowe zestawy zadań — z szablonu jednym kliknięciem powstaje projekt.',
        from: 'Z szablonu',
        manage: 'Zarządzaj szablonami',
        empty: 'Nie masz jeszcze szablonów. Utwórz je w zakładce „Szablony" albo zapisz projekt jako szablon (menu „…").',
        emptyTitle: 'Nie masz jeszcze szablonów',
        emptyText: 'Szablon to lista zadań, którą powtarzasz: pakowanie na wyjazd, przeprowadzka, sprzątanie przed świętami. Utwórz go tutaj albo zapisz projekt jako szablon.',
        count: '{n} zadanie | {n} zadania | {n} zadań',
        sections: '{n} sekcja | {n} sekcje | {n} sekcji',
        remove: 'Usuń szablon „{name}"',
        back: 'Wróć do szablonów',
        name: 'Nazwa szablonu',
        namePlaceholder: 'Nazwa szablonu, np. Pakowanie na wyjazd',
        editHint: 'Zmiany zapisują się same. Projekty już utworzone z szablonu się nie zmieniają.',
        use: 'Utwórz projekt',
        saved: 'Zapisano',
        saving: 'Zapisywanie…',
        saveError: 'Nie udało się zapisać — spróbujemy przy następnej zmianie',
        pickTitle: 'Wybierz szablon',
        pickText: 'Albo utwórz nowy. Szablon zrobisz też z gotowego projektu — „Zapisz jako szablon" w menu „…" projektu.',
    },
    help: {
        list: {
            title: 'Projekty',
            text: 'Projekt to coś z celem i końcem — remont, przeprowadzka, wyjazd — rozpisane na zadania. Przy każdym widać postęp i termin.',
            more: 'Przypięte są na górze. Zakończone projekty trafiają do „Zakończone" na dole listy i da się je przywrócić.',
        },
        project: {
            title: 'Projekt',
            text: 'Nazwę i zadania zmieniasz w miejscu — zapisuje się samo. Na pasku u góry: termin, przypięcie, zakończenie, a w „…" zapis jako szablon i usunięcie.',
            more: 'Termin projektu pokazuje się w Planerze w dniu terminu. Gdy wszystko jest odhaczone, projekt zaproponuje zakończenie.',
        },
        tasks: {
            title: 'Zadania i sekcje',
            text: 'Wpisz zadanie w „Dodaj zadanie" i naciśnij Enter — możesz wpisywać jedno po drugim albo wkleić kilka linii naraz. Sekcje (np. Kuchnia, Łazienka) grupują zadania.',
            more: 'Zadania przeciągasz między sekcjami za uchwyt. Ikona kalendarza ustawia dzień i godzinę — wtedy zadanie pojawi się w Planerze; powtarzanie i przypomnienie są w pełnym oknie zadania. Zrobione zjeżdżają do „Zrobione" na dole.',
        },
        fromTemplate: {
            title: 'Z szablonu',
            text: 'Nowy projekt z gotowego zestawu zadań, np. „Pakowanie na wyjazd".',
            more: 'Szablony tworzysz i zmieniasz w zakładce „Szablony" — albo zapisujesz gotowy projekt jako szablon w jego menu „…".',
        },
        templates: {
            title: 'Szablony',
            text: 'Listy zadań, które powtarzasz. Zmieniasz je w miejscu, a „Utwórz projekt" robi z szablonu nowy projekt.',
            more: 'Szablon pamięta sekcje. Zmiana szablonu nie rusza projektów, które już z niego powstały.',
        },
    },
    tour: {
        welcome: {
            title: 'Witaj w Projektach',
            description: 'Rzeczy z celem i końcem — remont, przeprowadzka, wyjazd — rozpisane na zadania. Zadanie z dniem trafia też do Planera.',
        },
        project: {
            title: 'W projekcie',
            description: 'Otwórz projekt z listy: zadania dopisujesz na dole grupy i odhaczasz kółkiem, sekcje grupują zadania, a ikona kalendarza przy zadaniu ustawia dzień i godzinę. Na górze termin, przypięcie i „Zakończ projekt".',
        },
        end: {
            title: 'To wszystko',
            description: 'Przewodnik wróci zawsze pod przyciskiem „Pomoc" — tam są też Pierwsze kroki. A „Co to?" przy sekcji wyjaśnia ją bez przewodnika.',
        },
    },
    firstSteps: {
        project: {
            title: 'Pierwszy projekt',
            action: 'Nowy projekt',
            what: 'Załóż projekt, np. „Remont łazienki", i wpisz kilka zadań.',
            why: 'Wszystko, co trzeba zrobić, w jednym miejscu — z postępem na pasku.',
        },
        section: {
            title: 'Sekcja w projekcie',
            action: 'Dodaj sekcję',
            what: 'Podziel projekt na etapy albo miejsca, np. Kuchnia i Łazienka.',
            why: 'Przy większym projekcie od razu widać, co zostało w której części.',
        },
        day: {
            title: 'Zadanie z dniem',
            action: 'Ustaw dzień zadania',
            what: 'Przy zadaniu kliknij ikonę kalendarza i wybierz dzień (i godzinę).',
            why: 'Zadanie pojawi się w Planerze tego dnia, z nazwą projektu.',
        },
        due: {
            title: 'Termin projektu',
            action: 'Ustaw termin',
            what: 'Na pasku projektu kliknij „Termin" i wybierz dzień.',
            why: 'Na liście widać, ile zostało, a w Planerze termin pokaże się w swoim dniu.',
        },
        template: {
            title: 'Szablon',
            action: 'Utwórz szablon',
            what: 'Zrób szablon z listy, którą powtarzasz — tutaj albo z projektu przez „Zapisz jako szablon".',
            why: 'Następnym razem projekt powstanie jednym kliknięciem.',
        },
    },
    toast: {
        undo: 'Cofnij',
        removed: 'Usunięto projekt',
        finished: 'Projekt zakończony',
        restored: 'Projekt przywrócony',
        taskRemoved: 'Usunięto zadanie',
        sectionRemoved: 'Usunięto sekcję „{name}" — zadania zostały',
        templateSaved: 'Zapisano szablon „{name}"',
        templateRemoved: 'Usunięto szablon „{name}"',
    },
    errors: {
        addTask: 'Nie udało się dodać zadania.',
        order: 'Nie udało się zapisać kolejności.',
        generate: 'Nie udało się utworzyć projektu z szablonu.',
    },
};
